import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import getVideoPosterUrl from 'components/pdp/carousel-images/image-carousel/image-carousel-auto-play-video/poster'

const HeroPosterPreload = ({ banner, isPhone }) => {
  const media = banner?.attributes?.media
  const poster = media?.kind === 'video' ? media.thumbnail_url : null
  const [request, setRequest] = useState(null)

  // The CDN sizing helper uses devicePixelRatio. Run only on the client,
  // as soon as the first banner is known, without waiting for skinny banners.
  useEffect(() => {
    setRequest(
      poster ? { poster, url: getVideoPosterUrl(poster, !isPhone) } : null,
    )
  }, [poster, isPhone])

  if (!poster || request?.poster !== poster) return null

  return (
    <Head>
      <link
        key="homepage-hero-poster"
        rel="preload"
        as="image"
        href={request.url}
        fetchpriority="high"
      />
    </Head>
  )
}

HeroPosterPreload.propTypes = {
  isPhone: PropTypes.bool,
  banner: PropTypes.shape({
    attributes: PropTypes.shape({
      media: PropTypes.shape({
        kind: PropTypes.string,
        thumbnail_url: PropTypes.string,
      }),
    }),
  }),
}

HeroPosterPreload.defaultProps = { banner: null, isPhone: true }

export default HeroPosterPreload
